import React from 'react';
import { Facebook, Linkedin, Instagram } from 'lucide-react';
import { Eyebrow } from '../ui';

const KBCDirectoryFooter = () => {
  return (
    <footer className="on-dark bg-navy hidden lg:block py-14 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

          {/* Company Info Section */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-4">
              <div className="flex items-center justify-center mr-2.5">
                <img
                  src="/image.png"
                  alt="profile"
                  className="h-8 w-8 rounded-md object-cover ring-1 ring-line/15"
                />

              </div>
              <div>
                <h2 className="font-display text-ink text-base font-bold text-left">KBC Directory</h2>
                <p className="text-xs text-muted text-left">Your trusted local business directory</p>
              </div>
            </div>
            <p className="text-text mb-4 text-sm leading-relaxed">
              The Kongu Business Community (KBC) is a collective of entrepreneurs, professionals, and visionaries united by a single purpose – to empower Kongu through business, collaboration, and innovation. Rooted in tradition and driven by modern enterprise, KBC is not just a network, but a movement that brings together Konguprenuers to grow, connect, and create extraordinary outcomes.
            </p>

            {/* Social Links */}
            <div className="flex gap-2">
              <a href="#" className="w-8 h-8 bg-surface2 border border-line/15 rounded-md flex items-center justify-center text-text hover:text-ink hover:border-line/30 transition-colors duration-150">
                <Facebook size={18} className="fill-current" />
              </a>
              <a href="#" className="w-8 h-8 bg-surface2 border border-line/15 rounded-md flex items-center justify-center text-text hover:text-ink hover:border-line/30 transition-colors duration-150">
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a href="#" className="w-8 h-8 bg-surface2 border border-line/15 rounded-md flex items-center justify-center text-text hover:text-ink hover:border-line/30 transition-colors duration-150">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-8 h-8 bg-surface2 border border-line/15 rounded-md flex items-center justify-center text-text hover:text-ink hover:border-line/30 transition-colors duration-150">
                <Linkedin size={18} className="fill-current" />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="sm:col-span-1 lg:col-span-1">
            <Eyebrow className="mb-6">Quick Links</Eyebrow>
            <ul className="space-y-4 text-left">
              <li>
                <a href="/home" className="text-muted hover:text-primary transition-colors text-sm">Home</a>
              </li>
              <li>
                <a href="/members" className="text-muted hover:text-primary transition-colors text-sm">Members</a>
              </li>
              <li>
                <a href="/categories" className="text-muted hover:text-primary transition-colors text-sm">Categories</a>
              </li>
              <li>
                <a href="/about" className="text-muted hover:text-primary transition-colors text-sm">About</a>
              </li>
              <li>
                <a href="/contact" className="text-muted hover:text-primary transition-colors text-sm">Contact</a>
              </li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="sm:col-span-1 lg:col-span-1">
            <Eyebrow className="mb-6">Support</Eyebrow>
            <ul className="space-y-4 text-left">
              <li>
                <a href="/contact" className="text-muted hover:text-primary transition-colors text-sm">Contact Us</a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-muted hover:text-primary transition-colors text-sm">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms" className="text-muted hover:text-primary transition-colors text-sm">Terms & Conditions</a>
              </li>
              <li>
                <a href="/legal" className="text-muted hover:text-primary transition-colors text-sm">Legal Notice</a>
              </li>
              {/* Installed as a PWA there is no address bar, so without this an
                  admin has no way to reach /admin from inside the app. The route
                  is already protected; only the link is being exposed. */}
              <li>
                <a href="/admin" className="text-muted hover:text-primary transition-colors text-sm">Admin Login</a>
              </li>
              {/* <li>
                <a href="#" className="text-muted hover:text-primary transition-colors text-sm">Legal Notice</a>
              </li> */}
            </ul>
          </div>

          {/* Contact Info Section */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Eyebrow className="mb-6">Contact Info</Eyebrow>
            <ul className="space-y-4 text-left">
              <li className="flex items-center">
                <div className="w-2 h-2 bg-primary rounded-full mr-3 flex-shrink-0"></div>
                <a href="mailto:admin@kbcmembers.org" className="text-muted hover:text-primary transition-colors text-sm">
                  admin@kbcmembers.org
                </a>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-primary rounded-full mr-3 flex-shrink-0"></div>
                <a href="tel:7305056436" className="text-muted hover:text-primary transition-colors text-sm">
                  7305056436
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-2 h-2 bg-primary rounded-full mr-3 flex-shrink-0 mt-1"></div>
                <div className="text-muted text-sm">
                  <div>Kongu Business Community,</div>
                  <div>NammaOffice,</div>
                  <div>3rd Floor, Balaji Towers,</div>
                  <div>Seerangapalayam, Salem-636007</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-line/15 text-center">
          <p className="text-muted text-sm">
            © 2025 KBC Directory. All rights reserved. |
            <a href="/privacy-policy" className="hover:text-primary transition-colors ml-1">Privacy Policy</a> |
            <a href="/terms" className="hover:text-primary transition-colors ml-1">Terms & Conditions</a> |
            <a href="/legal" className="hover:text-primary transition-colors ml-1">Legal Notice</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default KBCDirectoryFooter;
